import { fr as fr$1 } from 'date-fns/locale';
import merge from 'lodash/merge';
import error from './error.js';
import login from './login.js';

var fr = {
  language: 'fr',
  country: 'fr',
  name: 'Français',
  embeddedLocale: merge(error, login),
  flags: ['FR'],
  dateFns: fr$1,
  format: {
    date: 'd.MM.yyyy',
    dateTime: '$t(format:date) $t(format:time)',
    time: 'HH:mm',
  },
};

export { fr as default };
